require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-health-savings-accounts.json") })
        }
      }, "path---es-articles-health-savings-accounts");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-health-savings-accounts!./.cache/json/es-articles-health-savings-accounts.json
// module id = 2164
// module chunks = 231608221292675